/*
 * 2-2.12 «Печать расписания» — числа из макета «Доступы, вебхуки, печать - П2».
 *
 * Панель слева — экран кабинета, на токенах. ЛИСТ — БУМАГА: чёрный по белому и три серых,
 * заданные прямо, а не токенами. Тёмная тема кабинета не должна печатать чёрный лист,
 * а различимость статусов держится на знаках и штриховке, а не на цвете (ТЗ §2.3.3).
 * Лист на экране — 1000 × 707 (альбомный) и 707 × 1000 (книжный), как в макете;
 * на бумаге — во всю страницу A4 за вычетом полей @page.
 */

.screen {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding: var(--space-3) var(--space-4);
  overflow: auto;
}

.panel {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 10px;
  width: 260px;
  padding: 14px;
  font-size: 12.5px;
  line-height: 1.5;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.panelTitle {
  font-weight: var(--font-weight-semibold);
}

.modes {
  flex-direction: column;
  align-items: stretch;
}

.master {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.master select {
  height: 34px;
  padding: 0 8px;
  font: inherit;
  border: 1px solid var(--border-strong);
  border-radius: 8px;
}

.divider {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 10px;
  border-top: 1px solid var(--border);
}

.switchRow {
  justify-content: space-between;
}

.hint {
  font-size: 12px;
  color: var(--text-secondary);
}

.hintWarn {
  font-size: 12px;
  color: var(--danger-hover);
}

.preview {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

/* ─────────── лист ─────────── */

.sheet {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 28px 32px;
  overflow: hidden;
  font-family: Montserrat, system-ui, sans-serif;
  color: #000;
  background: #fff;
  border: 1px solid #d9cfbe;
  box-shadow: 0 6px 24px rgb(59 36 34 / 14%);
}

.landscape {
  width: 1000px;
  min-height: 707px;
}

.portrait {
  width: 707px;
  min-height: 1000px;
}

.sheetHeader {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  padding-bottom: 6px;
  border-bottom: 2px solid #000;
}

.salon {
  font-size: 15px;
  font-weight: 600;
}

.printed {
  font-size: 11px;
}

.grid {
  display: grid;
  flex: 1;
  min-height: 0;
  font-size: 9.5px;
  border: 1px solid #000;
}

.corner,
.colHead,
.hour,
.cell {
  border-right: 1px solid #000;
}

.corner,
.colHead {
  border-bottom: 1px solid #000;
}

.colHead {
  padding: 4px 6px;
  overflow: hidden;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.colWork {
  font-size: 8.5px;
  font-weight: 400;
}

.hour {
  padding: 2px 4px;
  font-variant-numeric: tabular-nums;
  border-bottom: 1px solid #999;
}

.cell {
  min-height: 34px;
  padding: 2px 4px;
  overflow: hidden;
  line-height: 1.2;
  background: #fff;
  border-bottom: 1px solid #999;
  break-inside: avoid;
}

.off {
  background: repeating-linear-gradient(135deg, #ddd 0 3px, transparent 3px 8px);
}

.cell-busy {
  background: #ccc;
}

.cell-noshow {
  background: repeating-linear-gradient(135deg, #bbb 0 2px, #fff 2px 6px);
}

.cell-done {
  background: #eee;
}

.cell-cont {
  background: repeating-linear-gradient(90deg, #fff 0 4px, #eee 4px 8px);
}

.cellTitle {
  overflow: hidden;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.bold {
  font-weight: 700;
}

.cellSub {
  overflow: hidden;
  font-size: 8.5px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.cont .cellTitle {
  font-weight: 400;
}

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 9.5px;
}

.listTitle {
  font-size: 13px;
  font-weight: 600;
}

.table {
  width: 100%;
  font-size: 10.5px;
  border-collapse: collapse;
}

.table thead tr {
  border-bottom: 1.5px solid #000;
}

.table th {
  padding: 4px 6px;
  text-align: left;
}

.table td {
  padding: 5px 6px;
  vertical-align: top;
}

.table tbody tr {
  border-bottom: 1px solid #999;
  break-inside: avoid;
}

.colTime,
.colStatus {
  width: 70px;
}

.colMin {
  width: 44px;
}

.strong {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.num {
  font-variant-numeric: tabular-nums;
}

.row-done {
  background: #f0f0f0;
}

.row-busy {
  background: #ddd;
}

.row-noshow {
  background: repeating-linear-gradient(135deg, #ccc 0 2px, #fff 2px 6px);
}

.emptyRow {
  color: #555;
  text-align: center;
}

/* ─────────── бумага ─────────── */

/* Копия листов для печати живёт порталом в body и на экране не видна. */
.printOnly {
  display: none;
}

@media print {
  :global(body > *:not(.plnr-print-host)) {
    display: none !important;
  }

  .printOnly {
    display: block;
  }

  .printOnly .sheet {
    width: auto;
    min-height: 0;
    height: auto;
    padding: 0;
    border: 0;
    box-shadow: none;
    break-after: page;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .printOnly .sheet:last-child {
    break-after: auto;
  }
}
